/**
 * DeleteConfirmationModal - Confirm permanent contact deletion
 * Shows clear warning that this action cannot be undone
 */
export default function DeleteConfirmationModal({ contact, onClose, onConfirm, isDeleting }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-[#1c1c1e] rounded-3xl max-w-md w-full shadow-2xl overflow-hidden">
        {/* Icon */}
        <div className="bg-red-50 dark:bg-red-500/10 px-6 pt-6 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-red-100 dark:bg-red-500/20 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4v2m0 4v2M6 18H6a3 3 0 003 3h6a3 3 0 003-3v-5a1 1 0 10-2 0v5a1 1 0 01-1 1H9a1 1 0 01-1-1v-5a1 1 0 10-2 0v5M9 9h6M9 9V7a3 3 0 013-3h0a3 3 0 013 3v2m-4 0h4" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 text-center space-y-4">
          <h2 className="text-xl font-semibold text-[#1d1d1f] dark:text-white">
            Delete Contact?
          </h2>

          <p className="text-[#1d1d1f] dark:text-white font-medium">
            {contact.nickname || contact.contactName || 'Unknown User'}
          </p>

          <div className="space-y-2 bg-red-50 dark:bg-red-500/10 p-4 rounded-xl border border-red-200 dark:border-red-500/20">
            <p className="text-sm font-semibold text-red-700 dark:text-red-400">
              ⚠️ This cannot be undone
            </p>
            <p className="text-sm text-[#6e6e73] dark:text-[#8e8e93]">
              {contact.nickname || contact.contactName} will be permanently removed from your contacts. You can re-add them later if needed.
            </p>
          </div>

          <p className="text-xs text-[#86868b] dark:text-[#8e8e93]">
            Any messages in your chat history will remain.
          </p>
        </div>

        {/* Actions */}
        <div className="p-6 border-t border-[#d2d2d7] dark:border-[#2c2c2e] flex gap-3">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1 px-4 py-2.5 text-[#1d1d1f] dark:text-white bg-[#f5f5f7] dark:bg-[#2c2c2e] hover:bg-[#e5e5ea] dark:hover:bg-[#424245] disabled:opacity-50 rounded-xl font-medium transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex-1 px-4 py-2.5 text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl font-medium transition-colors"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
